export default {
  Group: {
    Policies: 'Όροι'
  },

  PoliciesTerms: {
    Title: 'ΟΡΟΙ ΧΡΗΣΗΣ ΚΑΙ ΠΑΡΟΧΗΣ ΥΠΗΡΕΣΙΩΝ',
    Name : 'Όροι Χρήσης',
    Body : ``
  }
}
